import { useEffect, useRef, useState } from "react";
import { isPresenterSnapshot, WINDOW_PROTOCOL } from "./translationWindowProtocol";

export const useTranslationWindowBridge = (windowId) => {
  const [snapshot, setSnapshot] = useState(null);
  const activeRef = useRef(false);

  useEffect(() => {
    const origin = window.location.origin;
    const opener = window.opener;
    if (!opener) return;
    const request = () => {
      try {
        if (!opener.closed) opener.postMessage({ protocol: WINDOW_PROTOCOL, type: "request", windowId }, origin);
      } catch {
        // Standalone windows retain the existing localStorage fallback.
      }
    };
    const onMessage = (event) => {
      const data = event.data;
      if (event.origin !== origin || event.source !== opener || !data
          || data.protocol !== WINDOW_PROTOCOL || data.type !== "snapshot"
          || data.windowId !== windowId || !isPresenterSnapshot(data.snapshot)) return;
      // Latch the trusted source. Do not revert to stale local data during a
      // Dashboard reload/temporary disconnect; keep the last good snapshot.
      activeRef.current = true;
      setSnapshot(prev => JSON.stringify(prev) === JSON.stringify(data.snapshot) ? prev : data.snapshot);
    };
    window.addEventListener("message", onMessage);
    window.addEventListener("focus", request);
    request();
    const interval = setInterval(request, 1000);
    return () => {
      window.removeEventListener("message", onMessage);
      window.removeEventListener("focus", request);
      clearInterval(interval);
    };
  }, [windowId]);

  return { snapshot, activeRef };
};